export {
  getDataFromResponse,
  getDataPathologyTestResultFromResponse,
  pathologyReportColumns,
  pathologyReportWithResultsColumns,
} from './columns';
export { initialSearch, searchFields } from './config';
